module.exports = __webpack_public_path__ + "static/img/third_content_bg.f06a72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/third_content_bg.png
// module id = BTvR
// module chunks = 34